export function initializeMultiFactorAuthentication() {
  const twoFactorPromotionModal = window.Decidim.currentDialogs["two-factor-promotion-modal"];
  if (!twoFactorPromotionModal) {
    return;
  }
  twoFactorPromotionModal.open();
  const remindLaterButton = document.getElementById("two-factor-remind-later-button");
  const hidePermanentlyButton = document.getElementById("two-factor-hide-permanently-button");
  remindLaterButton.addEventListener("click", handleRemindLaterClickEvent);
  hidePermanentlyButton.addEventListener("click", handleHidePermanentlyClickEvent);
  function handleRemindLaterClickEvent() {
    const { actionUrl } = remindLaterButton.dataset;
    const url = new URL(location.origin + actionUrl);
    fetch(url, {
      method: "POST",
      headers: {
        "X-CSRF-Token": getCsrfToken(),
        "Content-Type": "application/json"
      }
    }).then(() => {
      twoFactorPromotionModal.close();
    });
  }
  function handleHidePermanentlyClickEvent() {
    const { actionUrl } = hidePermanentlyButton.dataset;
    const url = new URL(location.origin + actionUrl);
    fetch(url, {
      method: "POST",
      headers: {
        "X-CSRF-Token": getCsrfToken(),
        "Content-Type": "application/json"
      }
    }).then(() => {
      twoFactorPromotionModal.close();
    });
  }
}
function getCsrfToken() {
  return document.querySelector('meta[name="csrf-token"]').content;
}
